// Web polyfill for react-native-ssl-pinning
// SSL pinning is a mobile-only security feature
// On web, we use standard fetch with browser's built-in certificate validation

// fetch - fallback to standard web fetch
export const fetch = (url, options) => {
  // Web browsers handle SSL/TLS automatically
  return window.fetch(url, options);
};

// Default export
const reactNativeSSLPinning = {
  fetch,
};

export default reactNativeSSLPinning;

